module.exports = __webpack_public_path__ + "media/images/new_landing/logos/letgo-5e3eb3bac55922ed26ee9e23a1caba1f.png";